let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aArcw")).then(() => parcelRequire('eDZUG'));